import { BASE_URL, AUTH_HEADERS } from "./config";

export const getProjectSettings = async () => {
    const url = `${BASE_URL}/project-settings/`;
    try {
        const response = await fetch(url, {
            headers: AUTH_HEADERS
        });
        if (response.ok) {
            return await response.json();
        }
        throw new Error(`Failed to fetch project settings: ${response.statusText}`);
    } catch (error) {
        console.error("Error fetching project settings:", error);
        throw error;
    }
};
